import { getHustroClientHeaders } from 'shared/apiHeaders';
import { apiUrl } from 'shared/apiUrl';
import { MIME_TYPES } from 'shared/constants/MIME_TYPES';
import { SERVICE_UNAVAILABLE } from 'shared/contants';
import { frontendVersionWithBuildNumber } from 'shared/version';
import {
  buildSharedDocumentDownloadUrl,
  buildSharedReportDownloadUrl,
} from './sharedResourceDownloadUrls';
import {
  readSharedResourceSignedRequest,
  SharedDocumentSignedUrlRequest,
  SharedReportSignedUrlRequest,
  SharedResourceSignedRequestResult,
} from './sharedResourceSignedRequest';

export type SharedResourceRequest =
  | ({ entityType: 'report' } & SharedReportSignedUrlRequest)
  | ({ entityType: 'document' } & SharedDocumentSignedUrlRequest);

/** Same request the SW makes, for public download pages when the SW is unavailable. */
export async function fetchSharedResourceSignedRequest(
  request: SharedResourceRequest,
  signal?: AbortSignal
): Promise<SharedResourceSignedRequestResult> {
  const url =
    request.entityType === 'report'
      ? buildSharedReportDownloadUrl({
          apiUrl,
          reportId: request.reportId,
          token: request.token,
        })
      : buildSharedDocumentDownloadUrl({ apiUrl, ...request });

  let response: Response;
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': MIME_TYPES.JSON,
        ...getHustroClientHeaders(frontendVersionWithBuildNumber),
      },
      signal,
    });
  } catch (e) {
    if (signal?.aborted) {
      throw e;
    }
    return { statusCode: SERVICE_UNAVAILABLE };
  }

  const body: unknown = await response.json().catch(() => undefined);
  return readSharedResourceSignedRequest(response.status, body);
}
